<template>  
    <div class="info-form">  
      <form @submit.prevent="submitForm">  
        <div>  
          <label for="name">姓名:</label>  
          <input type="text" id="name" v-model="formData.name" >  
        </div>  
        <div>  
          <label for="examNumber">用户名:</label>  
          <input type="text" id="examNumber" v-model="formData.username" required>  
        </div>  
        <div>  
          <label for="idCard">密码:</label>  
          <input type="text" id="idCard" v-model="formData.password" required>  
        </div>  
        <div>  
          <label for="highSchool">手机号:</label>  
          <input type="text" id="highSchool" v-model="formData.phone">  
        </div>    
        <div class="button-group"> <!-- 新增一个包裹按钮的容器 -->
        <button type="submit">提交</button>
        <button type="close" @click="cancelForm()">取消</button>
      </div>  
      </form>  
    </div>  
  </template>  
    
  <script>  
  import axios from 'axios';  
  export default {  
    data() {  
      return {  
        formData: {  
          username:'',
          name:'',
          password:'',
          phone:'',   
        },  
        creator:JSON.parse(localStorage.getItem("username")),
      };  
    },  
    methods: {  
      submitForm() {  
        console.log('提交的信息:', this.formData); 
        axios.post('http://39.100.109.86:8093/user', { 
            username:this.formData.username,
            name:this.formData.name,
            password:this.formData.password,
            phone:this.formData.phone,  
            creator:this.creator
        })  
        .then(response => {  
          // 处理响应数据  
          console.log(response.data);  
          this.$router.push({ name: 'UserShow' });  
        })  
        .catch(error => {  
          // 处理错误  
          console.error(error);  
        });  
      },
      cancelForm() {  
            // 导航回Show.vue页面
            this.$router.push({ name: 'UserShow'});  
        }
    },  
  };  
  </script>  
    
  <style scoped>  
  .info-form {  
    /* 添加一些样式 */  
    padding: 20px;  
    border: 1px solid #ccc;  
    border-radius: 5px;  
  }  
  .info-form label {  
    display: block;  
    margin-bottom: 5px;  
  }  
  .info-form input[type="text"],  
  .info-form input[type="tel"] {  
    width: 100%;  
    padding: 5px;  
    box-sizing: border-box;  
  }  
  .info-form button {  
    margin-top: 10px;  
    padding: 5px 10px;  
  }  
  .info-form {
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
  max-width: 400px;
  margin: 0 auto;
}

.info-form label {
  display: block;
  margin-bottom: 5px;
  color: #555;
  font-weight: bold;
}

.info-form input[type="text"],
.info-form input[type="tel"] {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 15px;
  font-size: 14px;
}

.info-form input:focus {
  outline: none;
  border-color: #007bff;
}

.info-form button {
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.info-form button:hover {
  background-color: #0056b3;
}

.info-form a {
  color: crimson;
  text-decoration: none;
  font-size: 14px;
  display: inline-block;
  margin-top: 5px;
}

.errormsg {
  color: crimson;
  display: block;
  margin-top: 5px;
  font-size: 14px;
}
.button-group {
  display: flex; /* 使用Flexbox布局 */
  justify-content: space-between; /* 按钮间添加间距 */
  width: 100%; /* 确保按钮组填满容器宽度 */
  margin-top: 10px; /* 可根据需要调整与上一元素的间距 */
}

.button-group button {
  /* 根据需要自定义按钮样式，例如宽度、颜色等 */
  width: 36%; /* 两个按钮各占大约一半的宽度，留出一点间距 */
  padding: 10px 30px; /* 保持与已有按钮样式一致 */
}

</style>